// src/components/Header.js
import React from 'react';
import './Header.css';
import logo from '../assets/props_logo_blc_removebg.png'; // Adjust the path based on where your logo image is located
import Navbar2 from './Navbar2';

function Header() {
  return (
    <header className="app-header">
      <img src={logo} alt="Logo" className="logo" />
      <Navbar2 />
    </header>
  );
}

export default Header;
